import Vue from 'vue'
import { login, loginAuthUrl, getCurrentUser } from '../../api/api'
import {
  ACCESS_TOKEN,
  USER_INFO,
  THIRD_USER_INFO
} from '../mutation-types'

const user = {
  state: {
    accessToken: null,
    userInfo: {},
    thirdUserInfo: {}
  },

  mutations: {
    SET_ACCESS_TOKEN: (state, accessToken) => {
      state.accessToken = accessToken
    },
    SET_INFO: (state, userInfo) => {
      state.userInfo = userInfo
    },
    SET_THIRD_INFO: (state, thirdUserInfo) => {
      state.thirdUserInfo = thirdUserInfo
    },
  },

  actions: {
    // 登录
    Login ({ commit }, params) {
      commit('SET_INFO', {})
      Vue.ls.set(USER_INFO, {})
      commit('SET_THIRD_INFO', {})
      Vue.ls.set(THIRD_USER_INFO, {})
      return new Promise((resolve, reject) => {
        login(params).then(response => {
          if (response && response.code === 1) {
            const result = response.data
            commit('SET_ACCESS_TOKEN', result)
            Vue.ls.set(ACCESS_TOKEN, result)
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登出
    Logout ({ commit }) {
      commit('SET_ACCESS_TOKEN', '')
      Vue.ls.set(ACCESS_TOKEN, '')

      commit('SET_INFO', {})
      Vue.ls.set(USER_INFO, {})

      commit('SET_THIRD_INFO', {})
      Vue.ls.set(THIRD_USER_INFO, {})

      window.location.href = loginAuthUrl + `?to_url=${process.env.viewURL}/personal`
    },
    // 获取用户权限
    GetUsers ({ commit }) {
      return new Promise((resolve, reject) => {
        getCurrentUser().then(response => {
          const result = response.data
          // 保存用户信息
          commit('SET_INFO', result.user_info)
          Vue.ls.set(USER_INFO, result.user_info)
          commit('SET_THIRD_INFO', result.third_user)
          Vue.ls.set(THIRD_USER_INFO, result.third_user)
          resolve(result)
        }).catch(error => {
          reject(error)
        })
      })
    },
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js